module.exports = __webpack_public_path__ + "img/Big-O_complexity_Chart.351a24ae.jpeg";